import { axios } from '@/utils/request'
const api = {
  getLivingBroadcast: '/sso/liveBroadcastGroup/getLivingBroadcast'
}

export default api
export const getLivingBroadcast = async (params = {}) => axios.post(api.getLivingBroadcast, params)
